import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ConsistentRegisterForm} from "../../../auth/components/auth_card/ConsistentRegisterForm";
import {SocialAuth} from "../../../auth/components/auth_card/SocialAuth";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useSemanticSearchPostAuthNavigation} from "../../hooks/use_semantic_search_post_auth_navigation";
import {SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "../../tracking/semantic_search_amplitude_location";
import {AI_ASSISTANT_AUTH_CUSTOM_LABEL} from "../../tracking/semantic_search_gtm_events";

export const SemanticSearchAuthSignupForm = () => {
    const {completeAuthFlow} = useSemanticSearchPostAuthNavigation();

    const handleAuthSuccess = () => {
        void completeAuthFlow();
    };

    return (
        <div className={container}>
            <SocialAuth
                onAuthSuccess={handleAuthSuccess}
                userSource={UserSource.REGISTRATION}
                gtmSourceSection={AI_ASSISTANT_AUTH_CUSTOM_LABEL}
                amplitudePlacement={SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT}
                amplitudeLocation={SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
                authContext="registration"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <ConsistentRegisterForm
                onAuthSuccess={handleAuthSuccess}
                userSource={UserSource.REGISTRATION}
                gtmSourceSection={AI_ASSISTANT_AUTH_CUSTOM_LABEL}
                amplitudePlacement={SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT}
                amplitudeLocation={SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
                skipAmplitudeClickEvent
            />
        </div>
    );
};

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});

const separatorTextStyle = css({
    pt: 1.5,
    textAlign: "center"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ConsistentRegisterForm} from "../../../auth/components/auth_card/ConsistentRegisterForm";
import {SocialAuth} from "../../../auth/components/auth_card/SocialAuth";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useSemanticSearchPostAuthNavigation} from "../../hooks/use_semantic_search_post_auth_navigation";
import {SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT, SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "../../tracking/semantic_search_amplitude_location";
import {AI_ASSISTANT_AUTH_CUSTOM_LABEL} from "../../tracking/semantic_search_gtm_events";

export const SemanticSearchAuthSignupForm = () => {
    const {completeAuthFlow} = useSemanticSearchPostAuthNavigation();

    const handleAuthSuccess = () => {
        void completeAuthFlow();
    };

    return (
        <div className={container}>
            <SocialAuth
                onAuthSuccess={handleAuthSuccess}
                userSource={UserSource.REGISTRATION}
                gtmSourceSection={AI_ASSISTANT_AUTH_CUSTOM_LABEL}
                amplitudePlacement={SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT}
                amplitudeLocation={SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
                authContext="registration"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <ConsistentRegisterForm
                onAuthSuccess={handleAuthSuccess}
                userSource={UserSource.REGISTRATION}
                gtmSourceSection={AI_ASSISTANT_AUTH_CUSTOM_LABEL}
                amplitudePlacement={SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT}
                amplitudeLocation={SEMANTIC_SEARCH_AMPLITUDE_LOCATION}
                skipAmplitudeClickEvent
            />
        </div>
    );
};

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});

const separatorTextStyle = css({
    pt: 1.5,
    textAlign: "center"
});
